import {RootState} from '../Store';

export const initialState: Partial<RootState> = {};
